import React, { useEffect, useMemo, useState } from "react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import { Button } from "../../../../shadcn/components/ui/button";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { Input } from "../../../../shadcn/components/ui/input";
interface JointBidderCountModelProps {
  open: any;
  setOpen: any;
  handleSubmit: any;
}

export default function JointBidderCountModel({
  open,
  setOpen,
  handleSubmit,
}: JointBidderCountModelProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const form = useBetaForm({
    bidder_count: "",
  });
  const form_constraints = useMemo(
    () => ({
      bidder_count: {
        presence: {
          allowEmpty: false,
          message: "^Please enter the number of bidders",
        },
        numericality: {
          onlyInteger: true,
          greaterThan: 1,
          lessThanOrEqualTo: 25,
          message: "^Bidder count must be between 2 and 25",
        },
      },
    }),
    []
  );

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, [form_constraints, form]);

  return (
    <CustomModalLayout
      open={open}
      onClose={() => setOpen(false)}
      childrenClassName="pb-6 px-4 lg:px-8 mid:px-14 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] w-full max-w-xl mx-4 sm:mx-14 mid:mx-24 xl:mx-32 overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <div>
        <div className="flex items-center space-x-3">
          <div>
            <p className="font-openSans text-[22px] font-semibold text-brand-bgBlack text-center">
              Enter Number of Bidders
            </p>
            <p className="font-openSans text-[16px] text-gray-700 text-center mt-1">
              Please specify the total number of bidders, including yourself as
              the primary bidder.
            </p>
          </div>
        </div>

        <div className="w-full mt-6">
          <div className={`relative w-full`}>
            {/* {showVerifiedIcon && isVerified && (
            <div className="absolute top-1/3 right-2">
              <CheckIcon className="h-5 w-5" />
            </div>
          )} */}
            <Input
              // disabled={}
              type="number"
              maxLength={10}
              // placeholder={"Representative PAN Number*"}
              value={form.getField("bidder_count")}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                form.setField("bidder_count", value);
              }}
              className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-sm lg:text-web-body-md leading-3 lg:leading-4 text-brand-textLightGrey focus:border-brand-orange`}
            />
            <label
              htmlFor="mobile"
              className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
            >
              Bidder count
            </label>
            {form.errors.get("bidder_count") ? (
              <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                {form.errors.get("bidder_count")?.[0]}
              </p>
            ) : null}
          </div>
        </div>

        <div className="w-full mt-6 flex space-x-4">
          <Button
            type="submit"
            disabled={isSubmitting}
            onClick={async () => {
              setIsSubmitting(true);
              console.log("form.value: ", form.validate(), form);

              if (form.validate()) {
                await handleSubmit(form.value);
              }
              setIsSubmitting(false);
            }}
            className="bg-primary hover:bg-black text-white px-6 py-2 rounded-lg w-full disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
          <Button
            type="button"
            variant="outline"
            disabled={isSubmitting}
            className="px-6 py-2 rounded-lg w-full disabled:opacity-50"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </div>
      </div>
    </CustomModalLayout>
  );
}
